import styled from 'styled-components/macro';

export const FormWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;
